import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Label/label';
import { Button } from '../Button';
import { css } from '@patternfly/react-styles';
import TimesIcon from '@patternfly/react-icons/dist/js/icons/times-icon';
var colorStyles = {
  blue: styles.modifiers.blue,
  cyan: styles.modifiers.cyan,
  green: styles.modifiers.green,
  orange: styles.modifiers.orange,
  purple: styles.modifiers.purple,
  red: styles.modifiers.red,
  grey: ''
};
export var Label = function Label(_a) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$color = _a.color,
      color = _a$color === void 0 ? 'grey' : _a$color,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'filled' : _a$variant,
      icon = _a.icon,
      onClose = _a.onClose,
      closeBtn = _a.closeBtn,
      closeBtnProps = _a.closeBtnProps,
      href = _a.href,
      props = __rest(_a, ["children", "className", "color", "variant", "icon", "onClose", "closeBtn", "closeBtnProps", "href"]);

  var Component = href ? 'a' : 'span';
  var button = closeBtn ? closeBtn : React.createElement(Button, Object.assign({
    type: "button",
    variant: "plain",
    onClick: onClose
  }, Object.assign({
    'aria-label': 'label-close-button'
  }, closeBtnProps)), React.createElement(TimesIcon, null));
  return React.createElement("span", Object.assign({}, props, {
    className: css(styles.label, colorStyles[color], variant === 'outline' && styles.modifiers.outline, className)
  }), React.createElement(Component, Object.assign({
    className: css(styles.labelContent)
  }, href && {
    href: href
  }), icon && React.createElement("span", {
    className: css(styles.labelIcon)
  }, icon), children), onClose && button);
};